<template>
  <div class="page-wrapper py-4">
    <div id="master" ref="master" class="master" @scroll="handleScroll">
      <menutop :menu/>
      <page1 :pos="1" id="page1" class="section section-white" @sendAction="catchAction" />
      <page3 :pos="3" id="page3" class="section section-white" />
      <page4 :pos="4" id="page4" class="section section-white" />
      <page5 :pos="5" id="page5" class="section section-white" />
      <page6 :pos="6" id="page6" class="section section-white" />
      <page7 :pos="7" id="page7" class="section section-black" />
     
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import menutop from '@/components/structure/menutop.vue'
import page1 from '@/components/pages/page1.vue'
import page3 from '@/components/pages/page3.vue'
import page4 from '@/components/pages/page4.vue'
import page5 from '@/components/pages/page5.vue'
import page6 from '@/components/pages/page6.vue'
import page7 from '@/components/pages/page7.vue'

export default {
  name: 'HomeView',
  props:{
      con: {
          default: {},
          type: Object
      }
  },
  components: {
    menutop,
    page1,
    page3,
    page4,
    page5,
    page6,
    page7,
  },
  watch: {
    currentSection() {
      if(document.getElementById(`page${this.currentSection}`)) {
        document.getElementById(`page${this.currentSection}`).classList.contains('section-white') ? this.menu = 'white' : this.menu = 'black';
      }
    }
  },
  data() {
    return {
      menu: 'white',
      currentSection: 1,
    };
  },
  methods: {
    catchAction(data){
      switch(data.action){
        case 'setHeight':
          
          break;
        default:
          break;
      }
    },
    handleScroll() {
      const scrollPosition = this.$refs.master.scrollTop;
      const windowHeight = window.innerHeight;
      const menuHeight = 80; // Altura del menutop
      const adjustedScrollPosition = scrollPosition + menuHeight;
      const section = Math.floor(adjustedScrollPosition  / windowHeight) + 1;
      if (section < 1) {
        this.currentSection = 1;
      } else if (section > 7) {
        this.currentSection = 7;
      } else {
        this.currentSection = section;
      }
    },
 
  },
}
</script>

<style lang="css">
/* 1) El wrapper ocupa toda la pantalla */
.page-wrapper {
  background-color: #F0EFEB; /* background color */
  width: 100%;
  height: 96vh;
  display: flex;
  justify-content: center; /* centra .master horizontalmente */
  align-items: center;     /* centra .master verticalmente */
  box-sizing: border-box;
}

@media (max-width: 490px) {
  .d-none {
    display: none !important;
  }
}
/* body{
  background-color: white !important;
} */

/*
.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}
*/

.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);

  /* Firefox */
  scrollbar-width: none !important;
  /* IE 10+ */
  -ms-overflow-style: none !important;
}

/* Chrome, Safari, Opera */
.master::-webkit-scrollbar {
  display: none !important;
}

@media (max-width: 992px) {
  .master {
      padding-top: 0px !important;
  }
}
</style>